import { FC, ReactNode, useId, useState, useEffect } from 'react';
import { PasswordInput } from '@mantine/core';
import classNames from 'classnames';

import './styles.scss';

interface Props {
  label: string;
  placeholder: string;
  onChange?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  size?: 'lg' | 'md' | 'sm' | 'xl' | 'xs';
  withAsterisk?: boolean;
  className?: string;
  icon?: JSX.Element;
  disabled?: boolean;
  error?: ReactNode;
  mt?: string;
  required?: boolean;
  ariaLabel?: string;
  autoComplete?: string
}

const TextInput: FC<Props> = ({
  label,
  onChange,
  placeholder,
  size,
  withAsterisk,
  className,
  icon,
  onFocus,
  onBlur,
  disabled,
  error,
  required,
  ariaLabel,
  autoComplete,
}: Props): JSX.Element => {
  const id = useId();
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

  const setVisiblePassword = (visible: boolean): void => setIsPasswordVisible(visible);

  useEffect(() => {
    const element = document.getElementById(id);
    if (element !== null) element.setAttribute('aria-invalid', `${Boolean(error)}`);
  }, [error]);

  return (
    <div
      className={classNames('password_field_input', {
        ['error']: error,
      })}>
      <PasswordInput
        id={id}
        defaultVisible={isPasswordVisible}
        onVisibilityChange={setVisiblePassword}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        className={classNames(className)}
        onFocus={onFocus}
        onBlur={onBlur}
        rightSection={icon}
        disabled={disabled}
        label={label}
        withAsterisk={withAsterisk}
        toggleTabIndex={0}
        visibilityToggleLabel={`${isPasswordVisible ? 'Hide' : 'Show'} password`}
        required={required}
        // error={error}
        aria-label={ariaLabel}
        autoComplete={autoComplete}
      />
       {error && (
        <div id={`${id}-error`}  style={{
          paddingTop: '0.3125rem',
          fontSize : '0.875rem',
          color : '#a80000'
        }}  role="alert" aria-live="assertive" className="error-message">
          {error}
        </div>
      )}
    </div>
  );
};

export default TextInput;
